import { useState } from "react";
import { Plus, X, FileCheck2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";

export const DocChecklist = ({ docs, onChange }) => {
  const [name, setName] = useState("");
  const done = docs.filter((d) => d.received).length;
  const toggle = (i) => onChange(docs.map((d, j) => (j === i ? { ...d, received: !d.received } : d)));
  const remove = (i) => onChange(docs.filter((_, j) => j !== i));
  const add = () => { if (name.trim()) { onChange([...docs, { name: name.trim(), received: false }]); setName(""); } };

  return (
    <div className="sm:col-span-2 rounded-xl border border-slate-200 p-4 space-y-3" data-testid="doc-checklist">
      <div className="flex items-center justify-between">
        <p className="text-sm font-display font-semibold flex items-center gap-2"><FileCheck2 className="h-4 w-4 text-emerald-600" />Documenti</p>
        <span data-testid="doc-progress" className={`text-xs font-mono ${done === docs.length && docs.length ? "text-emerald-600" : "text-slate-500"}`}>{done}/{docs.length} ricevuti</span>
      </div>
      <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full bg-emerald-500 transition-[width] duration-300" style={{ width: `${docs.length ? (done / docs.length) * 100 : 0}%` }} />
      </div>
      <ul className="space-y-1.5">
        {docs.map((d, i) => (
          <li key={`${d.name}-${i}`} className="flex items-center gap-2.5 group">
            <Checkbox data-testid={`doc-check-${i}`} checked={d.received} onCheckedChange={() => toggle(i)} />
            <span className={`text-sm flex-1 ${d.received ? "line-through text-slate-400" : "text-slate-700"}`}>{d.name}</span>
            <button type="button" data-testid={`doc-remove-${i}`} onClick={() => remove(i)} className="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-rose-600 transition-opacity"><X className="h-3.5 w-3.5" /></button>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <Input data-testid="doc-new-input" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} placeholder="Aggiungi documento…" className="h-9" />
        <button type="button" data-testid="doc-add-btn" onClick={add} className="h-9 w-9 shrink-0 grid place-items-center rounded-md bg-slate-900 text-white hover:bg-sky-600 transition-colors"><Plus className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
